const Utill  = require("../utillity/utill");
const Calc   = require("../utillity/calculate");



module.exports.Before = function(){
	let tl = new TimelineMax();
	let $t = $('#pager');
	let $c = $('#pager__left, #pager__right');

	let len_w = ($(window).innerHeight() / 2 / Math.tan( Calc.ToRadian( 60 ) )) + ($(window).innerWidth() / 2);

	tl
		.set($t, {
			visibility: 'visible',
			ease: Power2.easeOut,
		}).to($c, Calc.ToSecond(570), {
			// width: '100%',
			width: len_w + 50,
			ease: Expo.easeOut,
			onComplete: AddMvClass,
		});

	function AddMvClass() {
		$('#mainvisual').removeClass('is_anim');
	};
};
module.exports.After  = function(){
	let tl = new TimelineMax();
	let $t = $('#pager');
	let $l = $('#pager__left');
	let $r = $('#pager__right');

	tl
		.set($l, {
			left: Calc.GetWidthByHeight( $(window).height() / 2 ) * -1,
			'transform-origin': '0 50%',
		})
		.set($r, {
			right: Calc.GetWidthByHeight( $(window).height() / 2 ) * -1,
			'transform-origin': '100% 50%',
		})
		.to($l, Calc.ToSecond(1200), {
			width: 0,
			ease: Expo.easeOut,
		}, '0')
		.to($r, Calc.ToSecond(1200), {
			width: 0,
			ease: Expo.easeOut,
		}, '0')
		// 初期化
		.set($t, {
			visibility: 'hidden',
		})
		.set($l, {
			left: '48%',
			'transform-origin': '100% 50%',
		})
		.set($r, {
			right: '48%',
			'transform-origin': '0 50%',
			onComplete: RemoveMvClass,
		});

	function RemoveMvClass() {
		$('#mainvisual').addClass('is_anim');
	};
};


// WEBPACK FOOTER //
// ./html/_src/js_wb/animation/paging.js